import { Grid } from "@mui/material";
import React, { useState } from "react";
import { Card } from "./styles";
import CustomButton from "../../components/Components/Button";
import Input from "../../components/Components/Input";
import { useMutation } from "react-query";
import { KeyCreation, guestCreation } from "./mutations/MasterDataMutations";
import { handleToastMsg } from "../../components/Components/Toast";
import { printBarcode } from "../../utils/printBarcode";
import CustomDivider from "../../components/Components/CustomDivider"

function MasterData({ setModelToggle }) {
  const [stepper, setStepper] = useState("DASHBOARD");
  const [keyName, setKeyName] = useState("");
  const [keyNumbers, setKeyNumbers] = useState("");
  const [guestName, setGuestName] = useState("");
  const [designation, setDesignation] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const { mutate } = useMutation(KeyCreation);
  const { mutate: guestMutate } = useMutation(guestCreation);

  const downloadImage = async (imageUrl) => {
    const response = await fetch(imageUrl, {
      method: "GET",
      headers: {
        Origin: `${process.env.REACT_APP_CORE_API}`,
      },
    });
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = blobUrl;
    a.download = "image.jpg"; // You can set the desired filename here
    document.body.appendChild(a);

    // Simulate a click on the link to trigger the download
    a.click();

    window.URL.revokeObjectURL(blobUrl);
    document.body.removeChild(a);
  };

  const submitKeyData = async (e) => {
    e.preventDefault();

    const payload = {
      key_type: keyName,
      quantity: keyNumbers,
    };

    mutate(payload, {
      onSuccess: (res) => {
        console.log({ res });
        // downloadImage(res.data.url);
        const printResult = printBarcode(res.data.barcodeValue)
        console.log({ printResult }, "printResult");
        if (printResult.success) {
          handleToastMsg("Data submitted successfully", "success");
        } else {
          handleToastMsg(printResult.message, "error");
        }
        handleToastMsg("Data submitted successfully", "success");
        setKeyName("");
        setKeyNumbers("");
        setModelToggle(false);
      },
      onError: (err) => {
        handleToastMsg(err.message, "error");
      },
    });
  };

  const handleGuestSubmit = (e) => {
    e.preventDefault();

    const name = `${guestName}(${designation})`;

    const payload = {
      name: name,
      role: designation,
      phone: phoneNumber,
    };

    guestMutate(payload, {
      onSuccess: (res) => {
        setGuestName("");
        setDesignation("");
        setPhoneNumber("");
        setModelToggle(false);
        handleToastMsg("Data submitted successfully", "success");
      },
      onError: (err) => {
        handleToastMsg(err.message, "error");
      },
    });
  };

  return (
    <>
      {stepper && stepper === "DASHBOARD" && (
        <Grid container width={"100%"} justifyContent={"center"} columnGap={4} style={{ paddingBottom: '2%' }}>
          <Grid item container justifyContent={"center"} py={2}>
            <h4>Master Data Editing</h4>
            <CustomDivider />
          </Grid>
          {/* <Card
            item
            container
            xs={3}
            justifyContent={"center"}
            alignItems={"center"}
            onClick={() => setStepper("GUESTS")}
          >
            <Grid item xs={12}>
              Guests
            </Grid>
          </Card> */}
          <Card
            item
            container
            xs={3}
            justifyContent={"center"}
            alignItems={"center"}
            onClick={() => setStepper("KEYS")}
          >
            {/* <img src={AavinImage} alt="cow" height={50} width={50} /> */}
            <Grid item xs={12}>
              Key
            </Grid>
          </Card>
        </Grid>
      )}

      {stepper === "GUESTS" && (
        <form onSubmit={handleGuestSubmit} style={{ width: "100%" }}>
          <Grid container width={"100%"} rowGap={3}>
            <Grid item container xs={6} columnGap={5}>
              <Grid item xs={3}>
                <p>Name:</p>
              </Grid>
              <Grid item>
                <Input
                  type="text"
                  value={guestName}
                  onChange={(e) => setGuestName(e.target.value)}
                />
              </Grid>
            </Grid>

            <Grid item container xs={6} columnGap={5}>
              <Grid item xs={3}>
                <p>Designation:</p>
              </Grid>
              <Grid item>
                <Input
                  type="text"
                  value={designation}
                  onChange={(e) => setDesignation(e.target.value)}
                />
              </Grid>
            </Grid>
            <Grid item container xs={6} columnGap={5}>
              <Grid item xs={3}>
                <p>Phone Number:</p>
              </Grid>
              <Grid item>
                <Input
                  type="text"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </Grid>
            </Grid>
            <Grid item container justifyContent={"flex-end"}>
              <CustomButton type="submit">Submit</CustomButton>
            </Grid>
          </Grid>
        </form>
      )}

      {stepper === "KEYS" && (
        <Grid container rowGap={4} alignItems={"center"}>
          <Grid item container justifyContent={"center"} py={2}>
            <h4>Add Key</h4>
            <CustomDivider />
          </Grid>
          <form style={{ width: "100%" }} onSubmit={submitKeyData}>
            <Grid item container rowGap={2} style={{ paddingLeft: '8%', paddingTop: '4%', paddingRight: '8%' }} justifyContent={'space-around'}>
              <Grid item container xs={4} alignItems={'center'}>
                <Grid item xs={12}>
                  <p>Name</p>
                </Grid>
                <Grid item xs={12}>
                  <Input
                    type="text"
                    value={keyName}
                    onChange={(e) => setKeyName(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Grid item container xs={4} alignItems={"center"}>
                <Grid item xs={12}>
                  <p>No of Keys</p>
                </Grid>
                <Grid item xs={12}>
                  <Input
                    type="text"
                    value={keyNumbers}
                    onChange={(e) => setKeyNumbers(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Grid item container justifyContent={"flex-end"} style={{ paddingTop: '4%' }}>
                <CustomButton type="submit">Submit</CustomButton>
              </Grid>
            </Grid>
          </form>
        </Grid>
      )}
    </>
  );
}

export default MasterData;
